export function setPrimaryColor(color: string) {
  const root = document.documentElement;
  root.style.setProperty('--color-theme-primary', `#${color}`);
}

export function setPrimaryColorOpaque(color: string) {
  const root = document.documentElement;
  root.style.setProperty('--color-theme-primary-opaque', `#${color}`);
}

export function setSecondaryColor(color: string) {
  const root = document.documentElement;
  root.style.setProperty('--color-theme-secondary', `#${color}`);
}

export function hexToRGB(hex: string) {
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);

  return { r, g, b };
}

export function blendHexColors(hex1: string, hex2: string, ratio: number): string {
  const rgb1 = hexToRGB(hex1);
  const rgb2 = hexToRGB(hex2);

  const r = Math.round(rgb1.r + (rgb2.r - rgb1.r) * ratio);
  const g = Math.round(rgb1.g + (rgb2.g - rgb1.g) * ratio);
  const b = Math.round(rgb1.b + (rgb2.b - rgb1.b) * ratio);

  return `${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}
